import React from 'react';
import UnifiedTagEditor from './unified-tag-editor';

const TagEditor: React.FC = () => {
  return (
    <UnifiedTagEditor
      mode="products"
      layout="cards"
      title="Products"
      emptyMessage="No products have been created yet. Click 'Add New Product' to create your first product."
      addButtonText="Add New Product"
      nameLabel="Product Name"
      descriptionLabel="Description"
    />
  );
};

export default TagEditor; 